

import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Card from "components/card";
import avatarFallback from "assets/img/avatars/avatar4.png";
import banner from "assets/img/profile/banner.png";
import { FaEdit, FaCheck, FaTimes } from "react-icons/fa";
import { API_BASE_URL } from "../../../../config";

const Banner = () => {
  const [admin, setAdmin] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [newName, setNewName] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/admin/get-admin`,
          { headers: { token } }
        );
        const adminData = response.data?.result?.admin;
        if (adminData) {
          setAdmin(adminData);
          setNewName(adminData.adminName);
        } else {
          toast.error("Admin not found");
        }
      } catch (error) {
        // console.error("Error fetching admin details:", error);
        toast.error("Failed to load admin details");
      }
    };

    if (token) fetchAdmin();
  }, [token]);

  const avatarUrl = admin?.adminName
    ? `https://ui-avatars.com/api/?name=${admin.adminName}`
    : avatarFallback;

  const role = admin?.isSuperAdmin ? "Super Admin" : "Admin";

  // Save updated admin name
  const handleSave = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/admin/edit-admin`,
        { adminName: newName },
        { headers: { token } }
      );

      if (response.data.success) {
        toast.success("Name updated successfully");
        setAdmin((prev) => ({ ...prev, adminName: newName }));
        setIsEditing(false);
      } else {
        toast.error(response.data.message || "Failed to update name");
      }
    } catch (error) {
      // console.error("Error updating admin name:", error);
      toast.error("Error updating name");
    }
  };

  return (
    <Card extra={"items-center w-full h-full p-[16px] bg-cover"}>
      {/* Banner background */}
      <div
        className="relative mt-1 flex h-32 w-full justify-center rounded-xl bg-cover"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] border-white bg-pink-400 dark:!border-navy-700">
          <img
            className="h-full w-full rounded-full object-cover"
            src={avatarUrl}
            alt={admin?.adminName || "Admin"}
          />
        </div>
      </div>

      {/* Name and role */}
      <div className="mt-16 flex flex-col items-center">
        <div className="flex items-center gap-2">
          {isEditing ? (
            <>
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                className="border rounded px-2 py-1 text-sm dark:text-[#000] text-[#000]"
              />
              <button
                onClick={handleSave}
                className="text-green-500 hover:text-green-700"
              >
                <FaCheck />
              </button>
              <button
                onClick={() => {
                  setIsEditing(false);
                  setNewName(admin?.adminName || "");
                }}
                className="text-red-500 hover:text-red-700"
              >
                <FaTimes />
              </button>
            </>
          ) : (
            <>
              <h4 className="text-xl font-bold text-navy-700 dark:text-white">
                {admin?.adminName || "Admin Name"}
              </h4>
              <button
                onClick={() => setIsEditing(true)}
                className="text-green-500 hover:text-gray-700"
              >
                <FaEdit />
              </button>
            </>
          )}
        </div>
        <p className="text-base font-normal text-gray-600 dark:text-white">
          {role}
        </p>
      </div>
    </Card>
  );
};

export default Banner;

